// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SmartBackup2_TheComp__S6VNr"};